/* eslint-disable no-param-reassign */
import Vue from 'vue'
import { ref, computed } from '@vue/composition-api'
import CorreiosService from '@/services/modules/CorreiosService'
import EnderecoModel from '@/models/components/endereco/Endereco'

export function atribuirNovoEnderecoAoAntigo(enderecoId, enderecoAntigo, enderecoNovo) {
  enderecoNovo = Object.values(enderecoNovo).every(it => !it) ? null : enderecoNovo

  if (!enderecoNovo) {
    return null
  }

  if (!enderecoAntigo.value) {
    enderecoNovo = new EnderecoModel({ id: enderecoId })
  }

  enderecoAntigo.value.bairro = enderecoNovo.bairro
  enderecoAntigo.value.cep = enderecoNovo.cep
  enderecoAntigo.value.cidade = enderecoNovo.cidade
  enderecoAntigo.value.complemento = enderecoNovo.complemento
  enderecoAntigo.value.estado = enderecoNovo.estado
  enderecoAntigo.value.numero = enderecoNovo.numero
  enderecoAntigo.value.rua = enderecoNovo.rua

  return enderecoAntigo
}

export default function useDadosCorreios(emit) {
  const enderecoData = ref(new EnderecoModel())
  const isGetDadosCorreiosLoading = ref(false)

  const cepFoiPreenchidoCorretamente = computed(() => enderecoData.value.cep && enderecoData.value.cep.length === 9)

  const bairroFoiPreenchidoPelaApiDosCorreios = ref(false)
  const ruaFoiPreenchidaPelaApiDosCorreios = ref(false)

  async function getDadosCorreio() {
    if (!cepFoiPreenchidoCorretamente.value) return

    isGetDadosCorreiosLoading.value = true

    const data = await CorreiosService.getByCep(enderecoData.value.cep)

    bairroFoiPreenchidoPelaApiDosCorreios.value = !!data.bairro
    ruaFoiPreenchidaPelaApiDosCorreios.value = !!data.rua

    if (data.cep) {
      enderecoData.value.cep = data.cep
      enderecoData.value.bairro = data.bairro
      enderecoData.value.rua = data.logradouro
      enderecoData.value.cidade = data.localidade
      enderecoData.value.estado = data.uf
    } else {
      Vue.$toast.clear()
      Vue.$toast.warning('CEP não encontrado')
      enderecoData.value.bairro = ''
      enderecoData.value.rua = ''
      enderecoData.value.cidade = ''
      enderecoData.value.estado = ''
    }

    isGetDadosCorreiosLoading.value = false
  }

  // watch(
  //   () => enderecoData.value.cep,
  //   v => {
  //     console.log('cep', v)

  //     if (!v) {
  //       enderecoData.value = new EnderecoModel()
  //     } else {
  //       // getDadosCorreio()
  //     }
  //   },
  // )

  function handleCepChange(v) {
    if (!v) {
      enderecoData.value = new EnderecoModel()
    } else {
      getDadosCorreio()
    }

    emit('update:cep', v)
  }

  return {
    enderecoData,
    isGetDadosCorreiosLoading,
    cepFoiPreenchidoCorretamente,
    bairroFoiPreenchidoPelaApiDosCorreios,
    ruaFoiPreenchidaPelaApiDosCorreios,
    handleCepChange,
  }
}
